exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".user-section {\n  margin: 15px 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  padding: 15px;\n  border-radius: 5px; }\n  .user-section h4 {\n    color: brown; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scenes/FieldArrayForm/style.scss
// module id = 593
// module chunks = 0